export default {
    appConfig: localStorage.getItem('appConfig') ? JSON.parse(localStorage.getItem('appConfig')) : null,

    revision: null,

    menuItems: [],
    companySites: [],
    appointmentStatus: {},
    selectedCompanySite: null,
    chat: false,
    appointments: false,
    appointmentsDate: null,
    defaultColor: 'rgba(23, 42, 208, 0.7)',
    patientSelect: false,
    unreadedMessageCount: 0,
    externalAppointmentCount: 0,
    envProfile: null
}
